// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"90a0f07a","228":"c1341690","240":"adc6da2d","284":"4b1f4ad6","376":"c1a52c03","752":"9f147cc5","964":"3bf28736","968":"3bf28736"}[chunkId] + ".chunk.css";
};